import React, {createContext, useCallback, useContext, useState} from "react";

export const OUTDATED_FRONT_TYPE = 'client-error:outdated-front';

const AppVersionContext = createContext({
    updateAvailable: false,
    notifyUpdateAvailable: () => {},
    blocked: false,
    notifyOutdated: () => {},
});

export const AppVersionContextExternal = {};

// Drapeau synchrone : l'état React ne serait lisible qu'au rendu suivant, trop tard
// pour les consommateurs de useFetch qui décident dans la même chaîne de microtâches.
export const outdatedFrontState = {isOutdated: false};

export const useAppVersion = () => useContext(AppVersionContext);

export default function AppVersionProvider({children}) {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [blocked, setBlocked] = useState(false);

    const notifyUpdateAvailable = useCallback(() => setUpdateAvailable(true), []);
    const notifyOutdated = useCallback(() => setBlocked(true), []);

    const valueProvided = {updateAvailable, notifyUpdateAvailable, blocked, notifyOutdated};

    Object.assign(AppVersionContextExternal, valueProvided);

    return (
        <AppVersionContext.Provider value={valueProvided}>
            {children}
        </AppVersionContext.Provider>
    );
}
